import React from "react";
import { Page, BlockTitle } from "framework7-react";
import { getMobileCustomFormMenuModuleNav, MobileNavList } from "./helpers";

const CustomFormMenuModuleSidebar = ({ menuId, custom_forms, custom_forms_menus }) => {
  const { menuLabel, items } = getMobileCustomFormMenuModuleNav(custom_forms_menus, menuId, custom_forms);

  return (
    <Page>
      <BlockTitle>{menuLabel}</BlockTitle>
      <MobileNavList items={items} />
    </Page>
  );
};

export default CustomFormMenuModuleSidebar;
